import ApiService from '../services/api.service'


const initialState = {
  config:{
    method: 'POST',
    url: 'http://192.168.7.20:8080/api/v.1/order-receive/create',
    baseURL: '/',
    data: null
  },
};

const state = () => ({...initialState});

const getters = {

};

const actions = {

  async sendForOrderProdutionData({commit}, config) {
    try {
      await ApiService.removeHeader();
      let response = await ApiService.customRequest(config)

      await ApiService.setHeader();
    } catch (e) {
      await ApiService.setHeader();
    }
  },
};

const mutations = {
    setOrderItem(state, payload) {
        state.config.data = payload
    }
};

export const orderProduction = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
